import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/Card';
import { useUserData } from '../../hooks/useUserData';

const CreditUsageSection: React.FC = () => {
  // Use the SAME REUSABLE hook as membership info - NO MORE DUPLICATE HOOKS!
  const { userInfo, isLoading, error } = useUserData();
  const balance = userInfo?.credits || 0;

  // Handle error state
  React.useEffect(() => {
    if (error) {
      console.error('Credit balance error:', error);
    }
  }, [error]);

  return (
    <Card className="bg-white border-gray-200 shadow-sm">
      <CardHeader className="p-4 sm:p-6">
        <CardTitle className="text-xl font-semibold text-gray-900">Credit & Usage</CardTitle>
        <p className="text-sm text-gray-600">Your current credit balance and usage statistics</p>
      </CardHeader>
      <CardContent className="p-4 sm:p-6">
        {/* Credit display temporarily removed */}
        <div className="bg-gray-50 rounded-xl p-4 sm:p-6 mb-4 sm:mb-6 border border-gray-200">
          <div className="space-y-4">
            <div className="flex justify-between items-start">
              <div>
                <h3 className="text-gray-600 text-sm font-medium mb-1">Current Balance</h3>
                <p className="text-gray-500 text-xs">Available credits remaining</p>
              </div>
              <div className="text-right">
                <div>
                  {isLoading ? (
                    <div className="text-3xl font-bold text-gray-400 mb-1 animate-pulse">...</div>
                  ) : (
                    <div className="text-3xl font-bold text-green-600 mb-1">{balance.toLocaleString()}</div>
                  )}
                  <p className="text-gray-500 text-xs">credits remaining</p>
                </div>
              </div>
            </div>
            <button 
              onClick={() => {
                // Navigate to pricing page with topup anchor
                window.location.href = '/pricing#topup';
              }}
              className="w-full py-3 bg-gradient-to-r from-blue-500 to-purple-600 text-white rounded-lg font-medium hover:from-blue-600 hover:to-purple-700 transition-all duration-200 shadow-sm hover:shadow-md"
            >
              Buy More Credits
            </button>
          </div>
        </div>

      </CardContent>
    </Card>
  );
};

export default CreditUsageSection;